import React, { useEffect, useRef, useState } from "react";
import { Form, Row, Col, Button, Tab, Nav, Container, Card, Toast } from "react-bootstrap";
import axios from "axios";
import Flex from "components/common/Flex";
import CommonBreadCrumb from "components/commonbreadcrumb/CommonBreadCrumb";
import paths from "routes/paths";
import { toast } from "react-toastify";
import DemoFileUpload from "components/orderdetail/DemoFileUpload";
import { useNavigate } from "react-router-dom";
import DatePicker from 'react-datepicker';
import moment from "moment";
import Select from "react-select";
import * as mapYourMedsConstant from '../../common/mapYourMedsConstant'
import FormValidations from "components/FormValidations/FormValidations";
import ThemedSelect from "components/commonbreadcrumb/ThemedSelect";
import AsyncSelect from "react-select/async";

const NavItem = ({ item, classNameCustom }) => {
    return (
        console.log(classNameCustom),
        <Nav.Item as="li" className={`${classNameCustom}`}>
            <Nav.Link
                className={`mb-0 py-3 px-1 cursor-pointer`}
                eventKey={item.toLowerCase().replaceAll(" ", "-")}>
                {item}
            </Nav.Link>
        </Nav.Item>
    );
};

const AddPatient = () => {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [activeKey, setActiveKey] = useState("client-information");
    const [navItems] = useState(['Client-Information', 'Insurance-Information']);
    const [errors, setErrors] = useState({})
    const formRef = useRef(null);
    const [imageUpload, setImageUploadFlag] = useState(false);
    const [stateoptions] = useState([{ key: 'Select a state', value: '' },
    ...mapYourMedsConstant.STATE_VALUES]);
    const [fileUpload, setFileUploadFlag] = useState(false);
    const [groupOptions, setGroupOptions] = useState([]);
    const [facilityobj, setFacilityObj] = useState({});
    const [selectedHcp, setSelectedHcp] = useState(null);
    const [diseaseOptions, setDiseaseOptions] = useState([]);
    const [selectedDiseases, setSelectedDiseases] = useState([]);
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        startOfCare: "",
        dob: "",
        gender: "",
        allergies: "",
        ssn: "",
        address1: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
        phone: "",
        mdName: "",
        mdPhone: "",
        diagnosis: "",
        disease: "",
        medicalCondition: "",
        note: "",
        insuranceName: "",
        pcn: "",
        groupNumber: "",
        bin: "",
        idNumber: "",
        medicareNumber: "",
        paymentMethod: "",
        responsibleParty: "",
        billingCity: "",
        billingZip: "",
        billingPhone: "",
        cardName: "",
        expirationDate: "",
        cardNumber: "",
        securityCode: "",
        streetAddress: "",
        billingState: "",
        email: "",
        group: "",
        facility: "",
        cell: "",
        document: null,
        is_createOrder: 0,
        physicalExamDate: "",
        middleName: "",
        nickname: "",
        race: "",
        height: "",
        weight: "",
        build: "",
        hair: "",
        eyes: "",
        distinguishingMarks: "",
        primaryLanguage: "",
        formerAddress: "",
        formerCity: "",
        formerState: "",
        formerZip: "",
        protectSelf: "",
        familyAddress: "",
        familyCity: "",
        familyState: "",
        familyZip: "",

        guardianName: "",
        legalCompetencyStatus: "",

        emergencyMedicalInfo: "",
        diagnoses: "",
        behaviorCharacteristics: "",
        responseToSearch: "",
        patternOfMovement: "",
        placesFrequented: "",
        relevantCapabilities: "",
        contactPerson: "",
        contactPhone: "",
        dds: ""

    });
    let groupList = JSON.parse(localStorage.getItem("groupsData")) ? JSON.parse(localStorage.getItem("groupsData")) : [];
    const facilityResults = JSON.parse(localStorage.getItem("facilitiesData"));
    const facilityResultsNew = JSON.parse(localStorage.getItem("facilitiesData"));
    const [options, setOptions] = useState(facilityResultsNew);
    const [selectedGroup, setSelectedGroup] = useState(groupList[0]);
    const facilitiesForGroup = selectedGroup
        ? facilityResults.filter(facility => facility.group_id === selectedGroup.value)
        : facilityResults[0];
    const [selectedFacility, setSelectedFacility] = useState(facilitiesForGroup);
    const currentRoleId = JSON.parse(localStorage.getItem("roleId"));
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [imageUploadedFiles, setImageUploadedFiles] = useState([]);
    const [allergy, setAllergy] = useState([]);
    const [hcp, setHcp] = useState([]);
    const [ddsDropDown, setDdsDropDown] = useState([]);

    useEffect(() => {
        setGroupAndFacility()
    }, [])

    useEffect(() => {
        getPatientAllergies();
    }, [])

    async function getPatientAllergies(id) {
        const getAllItems = {
            "dds": {},
        }
        let tokenStr = localStorage.getItem("accessToken");
        const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/patients//list-patient-allergies/` + (JSON.parse(localStorage.getItem("groupId")) || id || selectedGroup.value), {
            headers: { 'Authorization': `Bearer ${tokenStr}` }
        });
        const allergyDropdownOptions = response.data?.data?.map((item) => ({
            value: item.id,
            label: item.allergy,
        }));
        setAllergy(allergyDropdownOptions);

        await axios.post(`${process.env.REACT_APP_SERVER_URL}/prescriptions/fetch-multiple`, getAllItems, { headers: { 'Authorization': `Bearer ${tokenStr}` } })
            .then((res) => {
                const resultsDds = res?.data?.output?.data?.dds.map((item) => ({
                    key: item.name,
                    value: item.id
                }));
                setDdsDropDown([
                    { key: 'Select DDS', value: '' },
                    ...resultsDds
                ]);
            });
        //TODO confirm with SHANKS whether listing is based on facility id or not
        const { data } = await axios.get(`${process.env.REACT_APP_SERVER_URL}` + "/doctors/list-doctors/" + (JSON.parse(localStorage.getItem("groupId")) || id || selectedGroup.value), { headers: { 'Authorization': `Bearer ${tokenStr}` } });
        let results = []

        //console.log("Doctor Data Status " + data.status);
        let objPatientData = data.data;

        objPatientData.forEach((value) => {
            results.push({
                label: value.lastname + ", " + value.firstname,
                value: value.id,
                address: value.address || "" + "," + value.address2 || "",
                phone: value.phone,
            });
        });

        setHcp([
            ...results
        ])
    }

    const loadDiseaseOptions = async (inputValue) => {
        if (!inputValue) return [];

        try {
            const tokenStr = localStorage.getItem("accessToken");
            const response = await axios.post(
                `${process.env.REACT_APP_SERVER_URL}/patients/search-icd/`,
                { search: inputValue },
                { headers: { Authorization: `Bearer ${tokenStr}` } }
            );

            const mapped = response.data.data.map((item) => ({
                label: `${item.code} - ${item.description}`,
                value: item.id
            }));

            setDiseaseOptions(mapped);
            return mapped;

        } catch (err) {
            console.error("Disease loading error:", err);
            return [];
        }
    };

    async function setGroupAndFacility() {
        if (Number(localStorage.getItem("roleId")) < 4) {
            let temp = {};
            const groupResults = groupList.map((group) => {
                const facilitiesForGroup = facilityResults.filter(
                    (facility) => facility.group_id === group.value
                );

                temp[group.value] = facilitiesForGroup.map((facility) => ({
                    name: facility.key,
                    id: facility.value,
                }));

                return { key: group.key, value: group.value };
            });
            setGroupOptions([{ key: "Select Group", value: "" }, ...groupResults]);
            setFacilityObj(temp);
        }
    }

    const handleFileChange = (files) => {
        setUploadedFiles(files);
    };

    const handleImageChange = (files) => {
        setImageUploadedFiles(files)
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        if (name === "group") {
            const filtered = facilityData.filter((facility) => facility.group_id === parseInt(value));
            setFilteredFacilities(filtered);
            setFormData((prev) => ({ ...prev, facility: "" }));
        }
    };

    const handleNumberOnlyChange = (e) => {
        const { name, value } = e.target;
        const numericValue = value.replace(/\D/g, ''); // remove non-digits

        setFormData(prev => ({
            ...prev,
            [name]: numericValue
        }));
    };

    const handleGroupChange = async (selectedGroup) => {
        let tokenStr = localStorage.getItem("accessToken");
        setFormData(prev => ({
            ...prev,
            allergies: []
        }));
        getPatientAllergies(selectedGroup.value)
        setSelectedGroup(selectedGroup);
        const groupFacilityResults = facilityobj[selectedGroup.value]?.map((facility) => ({
            key: facility.name,
            value: facility.id,
        })) || [];
        setOptions([{ key: "Select a facility", value: "" }, ...groupFacilityResults]);
        setSelectedFacility({ key: "Select a facility", value: "" });
    };

    async function handleOptionSelect(selectedOption) {
        setSelectedFacility(selectedOption);
        if (Object.keys(facilityobj).length > 0) {
            const groupFacilityResults = facilityobj[selectedGroup.value]?.map((facility) => ({
                key: facility.name,
                value: facility.id,
            })) || [];
            setOptions([{ key: "Select a facility", value: "" }, ...groupFacilityResults]);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSubmitting) return;

        setIsSubmitting(true);
        var submissionData = new FormData();
        // Object.entries(formData).forEach(([key, value]) => {
        //     if (value !== null && value !== undefined) {
        //         if (key === "document" && value instanceof File) {
        //             submissionData.append(key, value);
        //         } else {
        //             submissionData.append(key, value.toString());
        //         }
        //     }
        // });

        // submissionData.append(uploadedFiles);

        //old payload
        // var submittedData = {
        //     create_order: formData.is_createOrder ? 1 : 0,
        //     group_id: JSON.parse(localStorage.getItem("groupId")) || selectedGroup.value,
        //     facility_id: selectedFacility.value,
        //     first_name: formData.firstName || "",
        //     last_name: formData.lastName || "",
        //     dob: moment(formData.dob).format("MM/DD/YYYY") || "",
        //     gender: formData.gender || "",
        //     admit_date: moment(formData.startOfCare).format("MM/DD/YYYY") || "",
        //     physical_exam_date: "",
        //     state: formData.state || "",
        //     city: formData.city || "",
        //     zip: formData.zip || "",
        //     ss_number: formData.ssn || "",
        //     allergies: formData.allergies || "",
        //     medsheet_note: formData.note || "",
        //     insurance_info: formData.insuranceName || "",
        //     insurance_group: formData.groupNumber || "",
        //     insurance_no: formData.idNumber || "",
        //     insurance_priority: "",
        //     is_active: "",
        // };

        let submittedData = {
            create_order: formData.is_createOrder ? 1 : 0,
            group_id: JSON.parse(localStorage.getItem("groupId")) || selectedGroup.value,
            facility_id: selectedFacility.value,
            first_name: formData.firstName,
            middle_name: formData.middleName,
            last_name: formData.lastName,
            nickname: formData.nickname,

            address: formData.address1,
            address2: formData.address2,
            city: formData.city,
            state: formData.state,
            zip: formData.zip,
            phone: formData.phone || "",
            fax: "",
            primary_language: formData.primaryLanguage,

            primary_language: "",
            ethnicity: "",
            race: formData.race,

            dob: formData.dob,
            gender: formData.gender,
            admit_date: moment(formData.startOfCare).format("MM/DD/YYYY") || "",
            physical_exam_date: moment(formData.physicalExamDate).format("MM/DD/YY") || "",
            ss_number: formData.ssn,
            client_admit: formData.is_createOrder ? 1 : 0,

            allergies: formData?.allergies.join(","),
            icd_codes: selectedDiseases.map(d => d.value).join(","),
            medsheet_note: formData.note,

            insurance_efs_information: "",
            insurance_group_no: formData.groupNumber,
            insurance_no: formData.idNumber,
            insurance_priority: "",

            not_capable_selfmeditating: "0",
            medication_independent_status: "",

            physician_id: selectedHcp ? selectedHcp.value : "",
            guardian_name: formData.guardianName,
            legal_competency_status: formData.legalCompetencyStatus,

            former_address: formData.formerAddress,
            former_city: formData.formerCity,
            former_state: formData.formerState,
            former_zip: formData.formerZip,

            family_address: formData.familyAddress,
            family_city: formData.familyCity,
            family_state: formData.familyState,
            family_zip: formData.familyZip,

            training_address: "",
            training_city: "",
            training_state: "",
            training_zip: "",
            training_phone: "",

            work_address: "",
            work_city: "",
            work_state: "",
            work_zip: "",

            height: formData.height,
            weight: formData.weight,
            build: formData.build,
            hair: formData.hair,
            eyes: formData.eyes,
            distinguishing_marks: formData.distinguishingMarks,

            emergency_medical_information: formData.emergencyMedicalInfo,
            diagnoses: formData.diagnoses,
            protect_self: formData.protectSelf || "",
            behavior_characteristics: formData.behaviorCharacteristics,
            response_to_search: formData.responseToSearch,
            pattern_of_movement: formData.patternOfMovement,
            places_frequented: formData.placesFrequented,
            relevant_capabilities: formData.relevantCapabilities,

            contact_person: formData.contactPerson,
            contact_phone: formData.contactPhone,
            dds_office_id: formData.dds || "",
            is_active: "1"
        };

        console.log(submittedData)
        Object.keys(submittedData).forEach(key => {
            submissionData.append(key, submittedData[key]);
        });
        if (formData.is_createOrder && uploadedFiles.length > 0) {
            uploadedFiles.forEach(file => {
                submissionData.append("documents", file, file.name);
            });
        }
        if (imageUploadedFiles.length > 0) {
            submissionData.append("patient_pic", imageUploadedFiles[0], imageUploadedFiles[0].name);
        }
        console.log("Submission Data:", submissionData);
        let tokenStr = localStorage.getItem("accessToken");
        try {
            const { data } = await axios.post(
                `${process.env.REACT_APP_SERVER_URL}/patients/add-patient`,
                submissionData,
                { headers: { 'Authorization': `Bearer ${tokenStr}` } }
            );

            if (data.status) {
                toast.success("Patient Details added successfully");
                navigate(paths.viewPatient);
            } else {
                toast.error("Error submitting the form. Please try again.");
            }
        } catch (error) {
            toast.error("Submission failed. Please check your input and try again.");
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleHcpChange = (selectedHcp) => {
        setSelectedHcp(selectedHcp);
    }

    const breadcrumbItems = [
        { name: 'Dashboard', href: '/main', isActive: false },
        { name: 'Add-Patient', href: paths.addPatient, isActive: true }
    ];

    const validateForm = (tab) => {
        let validationErrors = {};
        if (tab === "client-information") {
            if (!formData.firstName.trim()) validationErrors.firstName = "First Name is required";
            if (!formData.lastName.trim()) validationErrors.lastName = "Last Name is required";
            if (!formData.dob) validationErrors.dob = "Date of Birth is required";
            if (!formData.startOfCare) validationErrors.startOfCare = "Admit Date is required";
            if (!formData.gender) validationErrors.gender = "Gender is required";
            if (!formData.allergies) validationErrors.allergies = "Allergies are required";
            if (formData.zip.trim() && !FormValidations(formData.zip, 3)) {
                validationErrors.zip = "Zip Code format is not correct";
            }
            if (formData.formerZip.trim() && !FormValidations(formData.formerZip, 3)) {
                validationErrors.formerZip = "Zip Code format is not correct";
            }
            if (formData.familyZip.trim() && !FormValidations(formData.familyZip, 3)) {
                validationErrors.familyZip = "Zip Code format is not correct";
            }
            if (!selectedGroup?.value && currentRoleId < 4) validationErrors.group = "Group selection is required";
            if (!selectedFacility.value) validationErrors.facility = "Facility selection is required";
            if (formData.dob && moment(formData.dob).isAfter(moment())) {
                validationErrors.dob = "DOB cannot be in the future";
            }
            // if (imageUploadedFiles.length == 0) {
            //     setImageUploadFlag(true)
            //     validationErrors.document = "uploading Image is required";
            // } else {
            //     setImageUploadFlag(false)
            // }
            // if (formData.is_createOrder) {
            //     if (uploadedFiles.length == 0) {
            //         setFileUploadFlag(true);
            //         validationErrors.file = "uploading File is required";
            //     } else {
            //         setFileUploadFlag(false);
            //     }
            // }
        }

        if (tab === "insurance-information") {
            if (!formData.insuranceName.trim()) validationErrors.insuranceName = "Insurance Name is required";
            if (!formData.bin.trim()) validationErrors.bin = "BIN is required";
            if (!formData.pcn.trim()) validationErrors.pcn = "PCN is required";
            if (!formData.idNumber.trim()) validationErrors.idNumber = "ID Number is required";

            // if (formData.medicareNumber && !/^\d+$/.test(formData.medicareNumber)) {
            //     validationErrors.medicareNumber = "Medicare Number must be numeric";
            // }
        }

        setErrors(validationErrors);
        return Object.keys(validationErrors).length === 0;
    };

    const handleNext = async (e) => {
        e.preventDefault()
        if (!validateForm(activeKey)) {
            if (formRef.current) {
                formRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
            }
            return;
        }
        setImageUploadFlag(false);
        setFileUploadFlag(false);
        setActiveKey("insurance-information");
    }

    return (
        <>
            <CommonBreadCrumb breadcrumbItems={breadcrumbItems} />
            <Card ref={formRef}>
                <Tab.Container activeKey={activeKey} onSelect={(key) => setActiveKey(key)}>
                    <Card.Header
                        as={Flex}
                        justifyContent="between"
                        alignItems="center"
                        className="p-0 border-bottom patientInfoTabs"
                    >
                        <Nav
                            as="ul"
                            className="nav-tabs border-0 d-flex w-100 flex-nowrap chart-tab tab-active-caret p-0"
                        >
                            {navItems.map(item => (
                                <NavItem classNameCustom="col text-center" item={item} key={item} />
                            ))}
                        </Nav>
                    </Card.Header>
                    <Card.Body>
                        <Row className="g-1">
                            <Col xxl={12}>
                                <Tab.Content>
                                    <Tab.Pane eventKey="client-information">
                                        <Form>

                                            {/* ------------------------ SECTION: Pharmacy Enrollment ------------------------ */}
                                            <div className="p-3 mb-4 border rounded bg-light-subtle">
                                                <h5 className="mb-3 fw-bold">Pharmacy Enrollment</h5>
                                                <Row className="mb-3">
                                                    <Col>
                                                        <Form.Check
                                                            type="switch"
                                                            name="is_createOrder"
                                                            id="is_createOrder"
                                                            className="fs-5"
                                                            checked={formData.is_createOrder}
                                                            onChange={e =>
                                                                setFormData({
                                                                    ...formData,
                                                                    is_createOrder: e.target.checked
                                                                })
                                                            }
                                                            label="Add patient to Pharmacy"
                                                        />
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    {formData.is_createOrder ? (
                                                        <Col md={12} className="mb-2">
                                                            <DemoFileUpload
                                                                onFilesChange={handleFileChange}
                                                                textOfDoc={"Required Document"}
                                                                errorFlag={fileUpload}
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                {errors.file}
                                                            </Form.Control.Feedback>
                                                        </Col>
                                                    ) : []}
                                                </Row>
                                            </div>

                                            {/* ------------------------ SECTION: Group & Facility ------------------------ */}
                                            <div className="p-3 mb-4 border rounded bg-light-subtle">
                                                <h5 className="mb-3 fw-bold">Group & Facility Information</h5>

                                                <Row className="mb-3">
                                                    {currentRoleId < 4 && (
                                                        <Col xs="6" className="mb-0">
                                                            <Form.Group>
                                                                <Form.Label className="required">Group</Form.Label>
                                                                <ThemedSelect
                                                                    name="group"
                                                                    closeMenuOnSelect={true}
                                                                    placeholder="Select Group"
                                                                    classNamePrefix="react-select"
                                                                    className={`${errors.group ? "is-invalid" : ""}`}
                                                                    options={groupOptions}
                                                                    value={selectedGroup}
                                                                    getOptionLabel={option => option.key}
                                                                    getOptionValue={option => option.value}
                                                                    onChange={e => handleGroupChange(e)}
                                                                />
                                                                <Form.Control.Feedback type="invalid">
                                                                    {errors.group}
                                                                </Form.Control.Feedback>
                                                            </Form.Group>
                                                        </Col>
                                                    )}

                                                    <Col xs="6" className="mb-0">
                                                        <Form.Group>
                                                            <Form.Label className="required">Facility</Form.Label>
                                                            <ThemedSelect
                                                                name="facility"
                                                                closeMenuOnSelect={true}
                                                                placeholder="Select Facility"
                                                                classNamePrefix="react-select"
                                                                className={`${errors.facility ? "is-invalid" : ""}`}
                                                                options={options}
                                                                value={selectedFacility}
                                                                getOptionLabel={option => option.key}
                                                                getOptionValue={option => option.value}
                                                                onChange={e => handleOptionSelect(e)}
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                {errors.facility}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            </div>

                                            {/* ------------------------ SECTION: Personal Details ------------------------ */}
                                            <div className="p-3 mb-4 border rounded bg-light-subtle">
                                                <h5 className="mb-3 fw-bold">Personal Information</h5>

                                                <Row className="mb-3">
                                                    <Col md={6}>
                                                        <Form.Group controlId="firstName">
                                                            <Form.Label>
                                                                First Name<span className="text-danger">*</span>
                                                            </Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="firstName"
                                                                placeholder="First Name"
                                                                value={formData.firstName}
                                                                isInvalid={!!errors.firstName}
                                                                onChange={handleChange}
                                                                required
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                {errors.firstName}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={6}>
                                                        <Form.Group controlId="lastName">
                                                            <Form.Label>
                                                                Last Name<span className="text-danger">*</span>
                                                            </Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="lastName"
                                                                placeholder="Last Name"
                                                                value={formData.lastName}
                                                                isInvalid={!!errors.lastName}
                                                                onChange={handleChange}
                                                                required
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                {errors.lastName}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>

                                                <Row className="mb-3">
                                                    <Col md={12}>
                                                        <Form.Group>
                                                            <Form.Label>Nickname</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="nickname"
                                                                placeholder="Nickname"
                                                                value={formData.nickname}
                                                                onChange={handleChange}
                                                            />
                                                        </Form.Group>
                                                    </Col>

                                                    {/* <Col md={6}>
                                                        <Form.Group controlId="mrNumber">
                                                            <Form.Label>MR#</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="mrNumber"
                                                                placeholder="MR"
                                                                value={formData.mrNumber}
                                                                onChange={handleChange}
                                                            />
                                                        </Form.Group>
                                                    </Col> */}
                                                </Row>

                                                <Row className="mb-3">
                                                    <Col md={6}>
                                                        <Form.Group controlId="physicalExamDate">
                                                            <Form.Label>Physical Exam Date</Form.Label>
                                                            <DatePicker
                                                                placeholderText="mm/dd/yy"
                                                                selected={
                                                                    formData.physicalExamDate
                                                                        ? moment(formData.physicalExamDate).toDate()
                                                                        : null
                                                                }
                                                                onChange={date =>
                                                                    handleChange({
                                                                        target: {
                                                                            name: "physicalExamDate",
                                                                            value: moment(date).format("MM/DD/YYYY")
                                                                        }
                                                                    })
                                                                }
                                                                dateFormat="MM/dd/yy"
                                                                className="form-control"
                                                            />
                                                        </Form.Group>
                                                    </Col>

                                                    <Col md={6}>
                                                        <Form.Group controlId="startOfCare">
                                                            <Form.Label>Start Of Care</Form.Label>
                                                            <DatePicker
                                                                placeholderText="mm/dd/yy"
                                                                selected={
                                                                    formData.startOfCare
                                                                        ? moment(formData.startOfCare).format("MM/DD/YYYY")
                                                                        : null
                                                                }
                                                                onChange={date =>
                                                                    handleChange({
                                                                        target: {
                                                                            name: "startOfCare",
                                                                            value: moment(date).format("MM/DD/YY")
                                                                        }
                                                                    })
                                                                }
                                                                dateFormat="MM/dd/yy"
                                                                className={`form-control ${errors.startOfCare ? "is-invalid" : ""
                                                                    }`}
                                                            />
                                                            {errors.startOfCare && (
                                                                <div className="invalid-feedback mt-1 display-block">
                                                                    {errors.startOfCare}
                                                                </div>
                                                            )}
                                                        </Form.Group>
                                                    </Col>
                                                </Row>

                                                <Row className="mb-3">
                                                    <Col md={6}>
                                                        <Form.Group>
                                                            <Form.Label className="required">DOB</Form.Label>
                                                            <DatePicker
                                                                selected={
                                                                    formData.dob
                                                                        ? moment(formData.dob).format("MM/DD/YY")
                                                                        : null
                                                                }
                                                                onChange={date =>
                                                                    handleChange({
                                                                        target: {
                                                                            name: "dob",
                                                                            value: moment(date).format("MM/DD/YYYY")
                                                                        }
                                                                    })
                                                                }
                                                                dateFormat="MM/dd/yy"
                                                                placeholderText="mm/dd/yy"
                                                                showYearDropdown
                                                                minDate={moment().subtract(100, "years").toDate()}
                                                                maxDate={moment().toDate()}
                                                                scrollableYearDropdown
                                                                yearDropdownItemNumber={100}
                                                                className={`form-control ${errors.dob ? "is-invalid" : ""
                                                                    }`}
                                                            />
                                                            {errors.dob && (
                                                                <div className="invalid-feedback mt-1 display-block">
                                                                    {errors.dob}
                                                                </div>
                                                            )}
                                                        </Form.Group>
                                                    </Col>

                                                    <Col md={6}>
                                                        <Form.Group controlId="gender">
                                                            <Form.Label>
                                                                Gender<span className="text-danger">*</span>
                                                            </Form.Label>
                                                            <Form.Select
                                                                name="gender"
                                                                value={formData.gender}
                                                                isInvalid={!!errors.gender}
                                                                onChange={handleChange}
                                                                required
                                                            >
                                                                <option value="">Select Gender</option>
                                                                <option value="1">Male</option>
                                                                <option value="2">Female</option>
                                                                <option value="3">Others</option>
                                                            </Form.Select>
                                                            <Form.Control.Feedback type="invalid">
                                                                {errors.gender}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            </div>

                                            {/* ------------------------ SECTION: Medical Info ------------------------ */}
                                            <div className="p-3 mb-4 border rounded bg-light-subtle">
                                                <h5 className="mb-3 fw-bold">Medical Information</h5>

                                                <Row className="mb-3">
                                                    <Col md={6}>
                                                        <Form.Group controlId="allergies">
                                                            <Form.Label className="required">Allergies</Form.Label>
                                                            <Select
                                                                isMulti
                                                                options={allergy}
                                                                placeholder="Select Allergies"
                                                                value={allergy.filter(option =>
                                                                    formData.allergies.includes(option.value)
                                                                )}
                                                                classNamePrefix="react-select"
                                                                className={errors.allergies ? "is-invalid" : ""}
                                                                onChange={selectedOptions => {
                                                                    setFormData(prev => ({
                                                                        ...prev,
                                                                        allergies: selectedOptions.map(
                                                                            option => option.value
                                                                        )
                                                                    }));
                                                                }}
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                {errors.allergies}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Col>

                                                    <Col md={6}>
                                                        <Form.Group controlId="diagnosis">
                                                            <Form.Label>Diagnosis</Form.Label>
                                                            <AsyncSelect
                                                                isMulti
                                                                cacheOptions
                                                                defaultOptions={diseaseOptions}
                                                                loadOptions={loadDiseaseOptions}
                                                                value={selectedDiseases}
                                                                onChange={(options) => {
                                                                    setSelectedDiseases(options);
                                                                    setFormData(prev => ({
                                                                        ...prev,
                                                                        disease: options.map(o => o.value)
                                                                    }));
                                                                }}
                                                                classNamePrefix="react-select"
                                                                placeholder="Search disease..."
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>

                                                <Row className="mb-3">
                                                    {/* <Col md={6}>
                                                        <Form.Group controlId="medicalCondition">
                                                            <Form.Label>Medical Condition</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="medicalCondition"
                                                                placeholder="Medical Condition"
                                                                value={formData.medicalCondition}
                                                                onChange={handleChange}
                                                            />
                                                        </Form.Group>
                                                    </Col> */}

                                                    <Col md={12}>
                                                        <Form.Group controlId="note">
                                                            <Form.Label>Note</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="note"
                                                                placeholder="Note"
                                                                value={formData.note}
                                                                onChange={handleChange}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            </div>

                                            <div className="p-3 mb-4 border rounded bg-light-subtle">
                                                <h5 className="mb-3 fw-bold">Doctor Information</h5>

                                                <Row className="mb-3">
                                                    <Col>
                                                        <Form.Group controlId="doctorName">
                                                            <Form.Label>Physician`s Name</Form.Label>
                                                            <ThemedSelect
                                                                name="doctorName"
                                                                closeMenuOnSelect={true}
                                                                placeholder="Select Physician"
                                                                classNamePrefix="react-select"
                                                                options={hcp}
                                                                value={selectedHcp}
                                                                getOptionLabel={option => option.label}
                                                                getOptionValue={option => option.value}
                                                                onChange={e => handleHcpChange(e)}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Col md={6}>
                                                        <Form.Label>Physician`s ADDRESS</Form.Label>
                                                        <Form.Control
                                                            as="textarea"
                                                            name="doctorAddress"
                                                            value={selectedHcp ? selectedHcp.address : ''}
                                                            readOnly
                                                        />
                                                    </Col>
                                                    <Col md={6}>
                                                        <Form.Label>Physician`s PHONE</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="doctorPhone"
                                                            value={selectedHcp ? selectedHcp.phone : ''}
                                                            readOnly
                                                        />
                                                    </Col>
                                                </Row>
                                            </div>
                                            {/* ------------------------ SECTION: Identity & Physical Characteristics ------------------------ */}
                                            <div className="p-3 mb-4 border rounded bg-light-subtle">
                                                <h5 className="mb-3 fw-bold">Identity & Physical Characteristics</h5>

                                                <Row className="mb-3">
                                                    <Col md={4}>
                                                        <Form.Group>
                                                            <Form.Label>Race</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="race"
                                                                value={formData.race}
                                                                onChange={handleChange}
                                                            />
                                                        </Form.Group>
                                                    </Col>

                                                    <Col md={4}>
                                                        <Form.Group>
                                                            <Form.Label>Primary Language / Communication</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="primaryLanguage"
                                                                placeholder="English, Spanish etc."
                                                                value={formData.primaryLanguage}
                                                                onChange={handleChange}
                                                            />
                                                        </Form.Group>
                                                    </Col>

                                                    <Col md={4}>
                                                        <Form.Group controlId="protectSelf">
                                                            <Form.Label>Ability to Protect Self Without Assistance?</Form.Label>
                                                            <Form.Select
                                                                name="protectSelf"
                                                                value={formData.protectSelf}
                                                                onChange={handleChange}
                                                            >
                                                                <option value="">Select</option>
                                                                <option value="1">Yes</option>
                                                                <option value="0">No</option>
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>

                                                <Row className="mb-3">
                                                    <Col md={3}>
                                                        <Form.Group>
                                                            <Form.Label>Height</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="height"
                                                                value={formData.height}
                                                                onChange={handleNumberOnlyChange}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={3}>
                                                        <Form.Group>
                                                            <Form.Label>Weight</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="weight"
                                                                value={formData.weight}
                                                                onChange={handleNumberOnlyChange}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={3}>
                                                        <Form.Group>
                                                            <Form.Label>Build</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="build"
                                                                value={formData.build}
                                                                onChange={handleChange}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={3}>
                                                        <Form.Group>
                                                            <Form.Label>Hair</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="hair"
                                                                value={formData.hair}
                                                                onChange={handleChange}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>

                                                <Row className="mb-3">
                                                    <Col md={6}>
                                                        <Form.Group>
                                                            <Form.Label>Eyes</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="eyes"
                                                                value={formData.eyes}
                                                                onChange={handleChange}
                                                            />
                                                        </Form.Group>
                                                    </Col>

                                                    <Col md={6}>
                                                        <Form.Group>
                                                            <Form.Label>Distinguishing Marks</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="distinguishingMarks"
                                                                value={formData.distinguishingMarks}
                                                                onChange={handleChange}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>

                                                {/* Patient photo */}
                                                <Row className="mb-3">
                                                    <Col md={12}>
                                                        <Form.Group>
                                                            <DemoFileUpload
                                                                onFilesChange={handleImageChange}
                                                                textOfDoc={"Individual Image"}
                                                                errorFlag={imageUpload}
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                {errors.document}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            </div>

                                            {/* ------------------------ SECTION: Address Information ------------------------ */}
                                            <div className="p-3 mb-4 border rounded bg-light-subtle">
                                                <h5 className="mb-3 fw-bold">Address Information</h5>

                                                {/* Current Address */}
                                                <Row className="mb-3">
                                                    <Col md={6}>
                                                        <Form.Group controlId="address1">
                                                            <Form.Label>Address 1</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="address1"
                                                                value={formData.address1}
                                                                onChange={handleChange}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={6}>
                                                        <Form.Group controlId="address2">
                                                            <Form.Label>Address 2</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="address2"
                                                                value={formData.address2}
                                                                onChange={handleChange}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>

                                                <Row className="mb-3">
                                                    <Col md={4}>
                                                        <Form.Group controlId="city">
                                                            <Form.Label>City</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="city"
                                                                value={formData.city}
                                                                onChange={handleChange}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={4}>
                                                        <Form.Group controlId="state">
                                                            <Form.Label>State</Form.Label>
                                                            <Form.Select
                                                                name="state"
                                                                value={formData.state}
                                                                onChange={handleChange}
                                                            >
                                                                {stateoptions.map(option => (
                                                                    <option key={option.value} value={option.value}>
                                                                        {option.key}
                                                                    </option>
                                                                ))}
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={4}>
                                                        <Form.Group controlId="zip">
                                                            <Form.Label>Zip</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="zip"
                                                                className={`form-control form-control-sm ${errors.zip ? "is-invalid" : ""
                                                                    }`}
                                                                value={formData.zip}
                                                                onChange={handleNumberOnlyChange}
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                {errors.zip}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>

                                                {/* Former Address */}
                                                <h6 className="fw-semibold mt-3">Former Address</h6>

                                                <Row className="mb-3">
                                                    <Col md={6}>
                                                        <Form.Group>
                                                            <Form.Label>Former Address</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="formerAddress"
                                                                value={formData.formerAddress}
                                                                onChange={handleChange}
                                                            />
                                                        </Form.Group>
                                                    </Col>

                                                    <Col md={6}>
                                                        <Form.Group>
                                                            <Form.Label>Former City</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="formerCity"
                                                                value={formData.formerCity}
                                                                onChange={handleChange}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>

                                                <Row className="mb-3">
                                                    <Col md={6}>
                                                        <Form.Group>
                                                            <Form.Label>Former State</Form.Label>
                                                            <Form.Select
                                                                name="formerState"
                                                                value={formData.formerState}
                                                                onChange={handleChange}
                                                            >
                                                                {stateoptions.map(option => (
                                                                    <option key={option.value} value={option.value}>
                                                                        {option.key}
                                                                    </option>
                                                                ))}
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>

                                                    <Col md={6}>
                                                        <Form.Group>
                                                            <Form.Label>Former Zip</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="formerZip"
                                                                value={formData.formerZip}
                                                                onChange={handleNumberOnlyChange}
                                                                isInvalid={!!errors.formerZip}
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                {errors.formerZip}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={12}>
                                                        <Form.Group><Form.Label>DDS</Form.Label>
                                                            <Form.Select name="dds" value={formData.dds} onChange={handleChange}>
                                                                {ddsDropDown.map(opt => (
                                                                    <option value={opt.value} key={opt.value}>{opt.key}</option>
                                                                ))}
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            </div>

                                            {/* ------------------------ SECTION: Guardian & Legal ------------------------ */}
                                            <div className="p-3 mb-4 border rounded bg-light-subtle">
                                                <h5 className="mb-3 fw-bold">Guardian & Legal</h5>

                                                <Row className="mb-3">
                                                    <Col md={6}>
                                                        <Form.Group>
                                                            <Form.Label>If Legal Guardian, Name</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="guardianName"
                                                                value={formData.guardianName}
                                                                onChange={handleChange}
                                                            />
                                                        </Form.Group>
                                                    </Col>

                                                    <Col md={6}>
                                                        <Form.Group>
                                                            <Form.Label>Legal Competency Status</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="legalCompetencyStatus"
                                                                value={formData.legalCompetencyStatus}
                                                                onChange={handleChange}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            </div>

                                            {/* ------------------------ SECTION: Family Contacts ------------------------ */}
                                            <div className="p-3 mb-4 border rounded bg-light-subtle">
                                                <h5 className="mb-3 fw-bold">Family & Emergency Contacts</h5>

                                                <Row className="mb-3">
                                                    <Col md={6}>
                                                        <Form.Group>
                                                            <Form.Label>Family Address</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="familyAddress"
                                                                value={formData.familyAddress}
                                                                onChange={handleChange}
                                                            />
                                                        </Form.Group>
                                                    </Col>

                                                    <Col md={6}>
                                                        <Form.Group>
                                                            <Form.Label>Family City</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="familyCity"
                                                                value={formData.familyCity}
                                                                onChange={handleChange}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>

                                                <Row className="mb-3">
                                                    <Col md={6}>
                                                        <Form.Group>
                                                            <Form.Label>Family State</Form.Label>
                                                            <Form.Select
                                                                name="familyState"
                                                                value={formData.familyState}
                                                                onChange={handleChange}
                                                            >
                                                                {stateoptions.map(option => (
                                                                    <option key={option.value} value={option.value}>
                                                                        {option.key}
                                                                    </option>
                                                                ))}
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>

                                                    <Col md={6}>
                                                        <Form.Group>
                                                            <Form.Label>Family Zip</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="familyZip"
                                                                value={formData.familyZip}
                                                                onChange={handleNumberOnlyChange}
                                                                isInvalid={!!errors.familyZip}
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                {errors.familyZip}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>

                                                <Row className="mb-3">
                                                    <Col md={6}>
                                                        <Form.Group>
                                                            <Form.Label>Contact Person</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="contactPerson"
                                                                value={formData.contactPerson}
                                                                onChange={handleChange}
                                                            />
                                                        </Form.Group>
                                                    </Col>

                                                    <Col md={6}>
                                                        <Form.Group>
                                                            <Form.Label>Contact Person Phone</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="contactPhone"
                                                                value={formData.contactPhone}
                                                                onChange={handleChange}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            </div>

                                            {/* ------------------------ SECTION: Behavioral Profile ------------------------ */}
                                            <div className="p-3 mb-4 border rounded bg-light-subtle">
                                                <h5 className="mb-3 fw-bold">Behavioral Profile</h5>

                                                <Row className="mb-3">
                                                    <Col md={6}>
                                                        <Form.Group>
                                                            <Form.Label>Significant Behavior Characteristics</Form.Label>
                                                            <Form.Control
                                                                as="textarea"
                                                                name="behaviorCharacteristics"
                                                                value={formData.behaviorCharacteristics}
                                                                onChange={handleChange}
                                                            />
                                                        </Form.Group>
                                                    </Col>

                                                    <Col md={6}>
                                                        <Form.Group>
                                                            <Form.Label>Likely Response to Search Efforts</Form.Label>
                                                            <Form.Control
                                                                as="textarea"
                                                                name="responseToSearch"
                                                                value={formData.responseToSearch}
                                                                onChange={handleChange}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>

                                                <Row className="mb-3">
                                                    <Col md={6}>
                                                        <Form.Group>
                                                            <Form.Label>Pattern of Movement If Lost Previously</Form.Label>
                                                            <Form.Control
                                                                as="textarea"
                                                                name="patternOfMovement"
                                                                value={formData.patternOfMovement}
                                                                onChange={handleChange}
                                                            />
                                                        </Form.Group>
                                                    </Col>

                                                    <Col md={6}>
                                                        <Form.Group>
                                                            <Form.Label>Places Frequented</Form.Label>
                                                            <Form.Control
                                                                as="textarea"
                                                                name="placesFrequented"
                                                                value={formData.placesFrequented}
                                                                onChange={handleChange}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>

                                                <Row className="mb-3">
                                                    <Col md={12}>
                                                        <Form.Group>
                                                            <Form.Label>
                                                                Relevant Capabilities, Limitations and Preferences
                                                            </Form.Label>
                                                            <Form.Control
                                                                as="textarea"
                                                                name="relevantCapabilities"
                                                                value={formData.relevantCapabilities}
                                                                onChange={handleChange}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            </div>

                                            {/* ------------------------ FORM END / ACTION BUTTONS ------------------------ */}
                                            <Row>
                                                <Col className="d-flex justify-content-end">
                                                    <Button variant="primary" onClick={handleNext}>
                                                        Next
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="insurance-information">
                                        <Form onSubmit={handleSubmit}>
                                            <Row className="mb-3">
                                                <Col md={6}>
                                                    <Form.Group controlId="insuranceName">
                                                        <Form.Label>Insurance Name</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="insuranceName"
                                                            placeholder="Insurance Name"
                                                            value={formData.insuranceName}
                                                            onChange={handleChange}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6}>
                                                    <Form.Group controlId="bin">
                                                        <Form.Label>BIN</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="bin"
                                                            placeholder="BIN"
                                                            value={formData.bin}
                                                            onChange={handleChange}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <Col md={6}>
                                                    <Form.Group controlId="pcn">
                                                        <Form.Label>PCN</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="pcn"
                                                            placeholder="PCN"
                                                            value={formData.pcn}
                                                            onChange={handleChange}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6}>
                                                    <Form.Group controlId="idNumber">
                                                        <Form.Label>ID #</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="idNumber"
                                                            placeholder="ID"
                                                            value={formData.idNumber}
                                                            onChange={handleChange}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <Col md={6}>
                                                    <Form.Group controlId="groupNumber">
                                                        <Form.Label>Group #</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="groupNumber"
                                                            placeholder="Group #"
                                                            value={formData.groupNumber}
                                                            onChange={handleChange}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6}>
                                                    <Form.Group controlId="medicareNumber">
                                                        <Form.Label>Medicare Number (if Applicable)</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="medicareNumber"
                                                            placeholder="Medicare Number"
                                                            value={formData.medicareNumber}
                                                            onChange={handleChange}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className="d-flex justify-content-start">
                                                    <Button
                                                        variant="primary"
                                                        onClick={() => setActiveKey("client-information")}
                                                    >
                                                        Back
                                                    </Button>
                                                </Col>
                                                <Col className="d-flex justify-content-end">
                                                    <Button variant="primary" type="submit" disabled={isSubmitting}>
                                                        {isSubmitting ? "Submitting..." : "Submit"}
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </Tab.Pane>
                                </Tab.Content>
                            </Col>
                        </Row>
                    </Card.Body>
                </Tab.Container>
            </Card >
        </>
    );
};

export default AddPatient;
